/* @flow */

import React from 'react';
import { inject, observer } from 'mobx-react';
import { translate } from 'react-i18next';
import type { TranslatorProps } from 'react-i18next';

import ElectroSelectBasic from 'forms/components/inputs/ElectroSelectBasic/ElectroSelectBasic';
import { ComponentWithInjectedProps } from 'utils/injectedProps';
import RegionStore from 'stores/RegionStore';

import styles from './RegionSelect.module.scss';

export type RegionSelectProps = {
  value?: string,
  onSelect?: (newValue: string) => void,
};

type InjectedProps = {
  regionStore: RegionStore,
} & TranslatorProps;

const loadingOption = { id: 'Loading', name: 'Loading...' };

@translate()
@inject('regionStore')
@observer
export default class RegionSelect extends ComponentWithInjectedProps<
  RegionSelectProps,
  {},
  InjectedProps
> {
  constructor(props: *) {
    super(props);

    this.props.regionStore.loadRegions();
  }

  render() {
    const { regionStore, value, onSelect, t } = this.props;
    const { restricted, options } = regionStore.regionOptionsInfo;

    const optionsLoading = !options.length && regionStore.regionsLoading;

    const _options = [
      ...options.map(option => ({
        id: option.id,
        name: t(`general:regions.${option.name}`),
      })),
      ...(optionsLoading ? [loadingOption] : []),
    ];

    return (
      <div className={styles.regionSelectWrapper}>
        <ElectroSelectBasic
          style={{
            background: 'white',
            borderRadius: 5,
            paddingLeft: 10,
            paddingTop: 3,
            paddingBottom: 3,
          }}
          field={{
            value: optionsLoading
              ? loadingOption
              : value || regionStore.regions[regionStore.allRegionId],
            bind: () => ({ disabled: restricted }),
            options: _options,
            set: (key: string, newValue: string) => {
              if (key === 'value' && typeof onSelect === 'function') {
                onSelect(newValue);
              }
            },
          }}
        />
      </div>
    );
  }
}
